/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProcedureDiagnosisCodeViewModel } from './procedureDiagnosisCodeViewModel';

export interface UpdateProcedureTransactionViewModel {
  id?: string;
  visitId?: string;
  locationId?: string | null;
  procedureId?: string;
  nocProcedureDescription?: string | null;
  nationalDrugCodeId?: string | null;
  attendingProviderId?: string | null;
  referringProviderId?: string | null;
  primaryProviderId?: string | null;
  supervisingProviderId?: string | null;
  orderingProviderId?: string | null;
  serviceFromDate?: string;
  serviceToDate?: string;
  procedureAmount?: number;
  quantity?: number;
  postDate?: string;
  placeOfServiceCodeId?: string | null;
  modifier1Id?: string | null;
  modifier2Id?: string | null;
  modifier3Id?: string | null;
  modifier4Id?: string | null;
  accessionNumber?: string | null;
  drugUnit?: string | null;
  holdPatientBilling?: boolean | null;
  holdInsuranceBilling?: boolean | null;
  isReversed?: boolean;
  drugQuantity?: number | null;
  drugAmount?: number | null;
  prescriptionNumber?: string | null;
  drugCode?: string | null;
  insuranceAuthNumber?: string | null;
  claimComment?: string | null;
  chargeGroup?: number | null;
  externalId?: string | null;
  diagnoses?: Array<ProcedureDiagnosisCodeViewModel> | null;
  updateFee?: boolean;
}
